<template>
  <div class="similar-music-page">
    <aside
      class="similar-music-page__sidebar"
      :class="{ 'is-collapsed': sidebarCollapsed }"
    >
      <div class="similar-music-page__sidebar-header">
        <h2 v-show="!sidebarCollapsed" class="similar-music-page__sidebar-title">
          AI找音乐
        </h2>
        <button
          type="button"
          class="similar-music-page__toggle"
          :title="sidebarCollapsed ? '展开侧栏' : '收起侧栏'"
          @click="toggleSidebar"
        >
          <i :class="sidebarCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'" />
        </button>
      </div>
      <div v-show="!sidebarCollapsed" class="similar-music-page__sidebar-body">
        <HistoryPanel />
      </div>
    </aside>
    <main class="similar-music-page__main">
      <UploadPanel />
    </main>
  </div>
</template>

<script>
import { getToken } from '@/utils/author'
import HistoryPanel from './components/HistoryPanel.vue'
import UploadPanel from './components/UploadPanel.vue'

export default {
  name: 'SimilarMusicList',
  components: {
    HistoryPanel,
    UploadPanel
  },
  data() {
    return {
      sidebarCollapsed: false
    }
  },
  created() {
    this.checkLogin()
  },
  methods: {
    checkLogin() {
      if (!getToken()) {
        this.$store.dispatch('user/openLogin')
      }
    },
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    }
  }
}
</script>

<style lang="scss" scoped>
.similar-music-page {
  display: flex;
  min-height: 100vh;
  padding-top: 60px;
  box-sizing: border-box;
  background: #f5f5f5;

  &__sidebar {
    width: 300px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #ebebeb;
    background: #fff;
    transition: width 0.25s ease;

    &.is-collapsed {
      width: 48px;

      .similar-music-page__sidebar-header {
        padding: 0;
        justify-content: center;
      }

      .similar-music-page__toggle {
        margin-left: 0;
      }
    }
  }

  &__sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    padding: 0 12px 0 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #f0f0f0;
    flex-shrink: 0;
  }

  &__sidebar-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    margin-left: auto;
    font-size: 18px;
    color: #666;
    background: transparent;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    outline: none;
    flex-shrink: 0;

    &:hover {
      color: #e52a0d;
      background: rgba(229, 42, 13, 0.06);
    }
  }

  &__sidebar-body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  &__main {
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    // 页面已有 padding-top: 60px，再补 120px，距视口顶部共 180px
    padding: 120px 24px 40px;
    box-sizing: border-box;
    min-width: 0;
  }
}
</style>
